import { render } from "./WhatsNew.vue?vue&type=template&id=80e5276e&ts=true"
import script from "./WhatsNew.vue?vue&type=script&lang=ts"
export * from "./WhatsNew.vue?vue&type=script&lang=ts"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__